import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-general',
  templateUrl: './general-modal.component.html',
  styleUrls: ['./general-modal.component.css']
})
export class GeneralModalComponent implements OnInit {
  @Input() public title: any;
  @Input() public text: any;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
